import { TimeUnit } from "chart.js";
import { isInteger } from "lodash";
import {
  format,
  formatDate,
  getMonth,
  getWeek,
  getWeekDay,
} from "@backpacker/date";
import { Interval } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import {
  isSame,
  startOfDay,
  startOfMonth,
  startOfYear,
  tz,
} from "@tootools/date";
import { tr } from "@radarly/i18n";
import { Serie } from "./models";

export const formatXAxisTopLabel =
  (
    timeUnit: TimeUnit | Interval,
    locale: Locale,
    timezone: Timezone,
    series: Serie[]
  ) =>
  (value: string, index: number): string | number => {
    const date = series[0].data[index]?.date;
    const tdate = tz(date, timezone);
    if (timeUnit === "day" && isSame(tdate, startOfMonth(tdate), "day")) {
      return getMonth(locale, tdate, true);
    } else if (
      timeUnit === "hour" &&
      isSame(tdate, startOfDay(tdate), "hour")
    ) {
      return getWeekDay(locale, tdate);
    } else if (
      timeUnit === "month" &&
      isSame(tdate, startOfYear(tdate), "month")
    ) {
      return formatDate(tdate, locale, "YYYY");
    } else if (timeUnit === "week" && getWeek(tdate, locale) === 1) {
      return formatDate(tdate, locale, "YYYY");
    }
    return null;
  };

export const formatXAxisBottomLabel =
  (
    timeUnit: TimeUnit | Interval,
    locale: Locale,
    timezone: Timezone,
    series: Serie[]
  ) =>
  (value: string, index: number): string | number => {
    const date = series[0].data[index]?.date;
    if (timeUnit === "day") {
      return formatDate(tz(date, timezone), locale, "D");
    } else if (timeUnit === "hour") {
      return formatDate(tz(date, timezone), locale, "LT");
    } else if (timeUnit === "month") {
      return getMonth(locale, tz(date, timezone), true);
    } else if (timeUnit === "week") {
      const formatedDay = format(date, timezone, "YYYY-MM-DD");
      const numberOfWeek = getWeek(formatedDay, locale);
      return tr(locale, "CHARTY::DATE::WEEK", { weekNumber: numberOfWeek });
    }
    return date;
  };

export const formatYAxisLabel = (value) => {
  const convertedValue = value / 1000;
  return isInteger(convertedValue)
    ? convertedValue === 0
      ? "0"
      : convertedValue + "k"
    : null;
};

export const formatDateTitle = (timeUnit, date, locale, timezone) => {
  if (timeUnit === "month") {
    return getMonth(locale, tz(date, timezone), true);
  }
  return new Date(date).toLocaleString(locale.split("_")[0], {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
